import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useLocation } from 'react-router-dom';

import { SystemNotice } from '../../models/systemNotice/systemNotice';
import { systemNoticesService } from '../../services/system-notices.service';
import { getReadSystemNoticeIds, markSystemNoticeRead } from '../../services/utils/systemNoticesStorage';
import SystemNoticesDialog from './SystemNoticesDialog';

// Controleert bij elke paginanavigatie of er nog ongelezen systeemmeldingen zijn en toont deze geforceerd in een dialog.
const SystemNoticesGate: React.FC = () => {
  const { accounts } = useMsal();
  const location = useLocation();

  const [notices, setNotices] = useState<SystemNotice[]>([]);
  const [open, setOpen] = useState(false);
  const inFlight = useRef(false);
  const dismissedPathRef = useRef<string | null>(null);

  const userKey = accounts[0]?.username ?? null;

  const check = useCallback(async () => {
    if (inFlight.current) {
      return;
    }
    inFlight.current = true;
    try {
      const active = await systemNoticesService.getActiveNotices();
      const readIds = getReadSystemNoticeIds(userKey);
      const unread = active.filter((notice) => !readIds.has(notice.id));
      if (unread.length > 0) {
        setNotices(unread);
        setOpen(true);
      }
    }
    finally {
      inFlight.current = false;
    }
  }, [userKey]);

  useEffect(() => {
    if (dismissedPathRef.current === location.pathname) {
      return;
    }
    if (open) {
      return;
    }
    void check();
  }, [location.pathname, check, open]);

  const handleRead = (notice: SystemNotice) => {
    markSystemNoticeRead(notice, userKey);
  };

  const handleClose = () => {
    dismissedPathRef.current = location.pathname;
    setOpen(false);
    setNotices([]);
  };

  return (
    <SystemNoticesDialog
      open={open}
      notices={notices}
      onClose={handleClose}
      onRead={handleRead}
    />
  );
};

export default SystemNoticesGate;
